import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Grid, Box, Typography, Card } from '@mui/material';
import Campaigns from './Campaigns';
import Devices from './Devices';
import Impressions from './Impressions';
import { BaseErrorBoundry } from '../Common/BaseErrorBoundry';
import Rating from '@mui/material/Rating';
import CampaignDetails from './CampaignDetails';
import * as utils from '../../util/bellplus-utils';
import {
	getFeedbackByUser,
	createFeedback,
	updateFeedback,
} from '../../services/feedback.service';
import { ToastsStore, ToastsContainer, ToastsContainerPosition } from 'react-toasts';
import { useAppDispatch, useAppSelector } from 'Stores/Hooks/hooks';
import { dashboardData, dashboardState } from 'Stores/Slices/dashboardSlice';
import { RootState } from 'Stores/store';
const PREFIX = 'DashboardParent';

const classes = {
    grid: `${PREFIX}-grid`,
    chart: `${PREFIX}-chart`,
    ratingDOM: `${PREFIX}-ratingDOM`,
    cardContainer: `${PREFIX}-cardContainer`,
    card: `${PREFIX}-card`,
    campaignGridItem: `${PREFIX}-campaignGridItem`,
    salesGraphGridItem: `${PREFIX}-salesGraphGridItem`
};
const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.grid}`]: {
		flexWrap: 'nowrap'
	},

    [`& .${classes.chart}`]: {
	},

    [`& .${classes.ratingDOM}`]: {
		fontWeight: 600,
	},

    [`& .${classes.cardContainer}`]: {
		width: '100%',
		height: '100%',
	},

    [`& .${classes.card}`]: (props: any) => ({
		width: '100%',
		[theme.breakpoints.down('md')]: {
			height: `calc(${props.smDown}/${2})`,
		},
		[theme.breakpoints.down('lg')]: {
			height: `calc(${props.mdDown}/${2})`,
		},
		[theme.breakpoints.down('xl')]: {
			height: `calc(${props.lgDown}/${2})`,
		},
		[theme.breakpoints.down('xl')]: {
			height: `calc(${props.xlDown}/${2})`,
		},
		[theme.breakpoints.up('xl')]: {
			height: `calc(${props.xlUp}/${2})`,
		},
	}),

    [`& .${classes.campaignGridItem}`]: (props: any) => ({

	}),

    [`& .${classes.salesGraphGridItem}`]: (props: any) => ({
		[theme.breakpoints.down('md')]: {
			height: `calc(${props.smDown}+${props.smDown})`,
		},
		[theme.breakpoints.down('lg')]: {
			height: `calc(${props.mdDown}+${props.mdDown})`,
		},
		[theme.breakpoints.down('xl')]: {
			height: `calc(${props.lgDown}+${props.lgDown})`,
		},
		[theme.breakpoints.down('xl')]: {
			height: `calc(${props.xlDown}+${props.xlDown})`,
		},
		[theme.breakpoints.up('xl')]: {
			height: `calc(${props.xlUp}+${props.xlUp})`,
		},
	})
}));

export const dashboardHeights = {
	smDown: '120px',
	mdDown: '160px',
	lgDown: '200px',
	xlDown: '240px',
	xlUp: '280px',
};

function DashboardParent() {
	const [hover] = React.useState(-1);
  const dispatch = useAppDispatch();
	const [value, setValue] = React.useState<number | null>(0);
	const dashboardStore: dashboardState = useAppSelector((state: RootState) => state.dashboard);
	const { data: sampleData } = dashboardStore;
	const user = utils.getData('userDetails').data;
	const {width, height} = window.screen;

	const [feedback, setFeedback] = useState({
		id: null,
		rating: 0,
		userId: 0,
		comments: null,
	});
	useEffect(() => {
		dispatch(dashboardData());

		const getFeedback = async () => {
			const getFeedbackObj = await getFeedbackByUser();
			setFeedback(getFeedbackObj);
			setValue(getFeedbackObj.rating);
		};
		getFeedback();
	}, [dispatch]);

	const submitForm = async (newValue: any) => {
		const requestData = {
			rating: newValue,
			comments: '',
		};
		try {
			let resp: any;
			if (feedback.id === null) {
				resp = await createFeedback(requestData);
				setFeedback(resp.data.data);
			} else {
				resp = await updateFeedback(feedback.id, requestData);
			}

			if (
				resp !== undefined &&
				resp.data &&
				resp.data.errors !== undefined &&
				resp.data.errors.length === 0
			) {
				ToastsStore.success('Feedback saved successfully', 8000, 'toast-styles');
			} else if (resp === 'error') {
				ToastsStore.error('Feedback creation failed ', 8000);
			}
		} catch (errorObj) {
			//setHasError(errorObj);
		}
	};
	return (
        (<Root>
{sampleData && sampleData.runningCampaignResponse && (
				<Grid container direction="column" className={classes.grid} spacing={1}>
					<Grid item xs={12} className={classes.campaignGridItem}>

						<CampaignDetails
							data={
								sampleData.runningCampaignResponse
							}></CampaignDetails>

					</Grid>
					<Grid item xs={12} className={classes.salesGraphGridItem}>

						<Impressions
							dateArray={sampleData.viewershipDateList}
							actualList={sampleData.actualViewershipCountList}
							potentialList={
								sampleData.potentialViewershipCountList
							}></Impressions>

					</Grid>
					<Grid container item xs={12} className={classes.card}>
						<Card elevation={4} className={classes.cardContainer}>
							<Grid container direction="row">
								<Grid item>
									<Typography
										variant="h4"
										className={classes.ratingDOM}>
										Feedback
									</Typography>
								</Grid>
								<Grid item>
									<Rating
										className={classes.ratingDOM}
										name="hover-feedback"
										precision={0.1}
										value={value}
										onChange={(event, newValue) => {
											setValue(newValue);
											submitForm(newValue);
										}}
									/>
								</Grid>
							</Grid>
						</Card>
					</Grid>
				</Grid>
			)}
        </Root>)
    );
}

export default DashboardParent;
